import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';
import { SubscriptionItem } from './SubscriptionItem';
import { subscription } from '../../../model/subscription';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: reminder, done: boolean) => void;
    onSubscriptionClick: (id: string) => void;
    subscriptionList: Array<subscription>;
    selectedId: string;
    // showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}

export const SubscriptionList = (props: IProps) => {
    const classes = props.classes;
    return (
        <List className={classes?.root}>
            {props.subscriptionList && props.subscriptionList.map(s =>
                <SubscriptionItem
                    key={s._id}
                    classes={classes}
                    isSelected={props.selectedId === s._id}
                    subscription={s}
                    onSubscriptionClick={props.onSubscriptionClick}
                // doneReminder={props.doneReminder}
                // showContactInfo={props.showContactInfo}
                // navigateTo={props.navigateTo}
                />)}
        </List>)
};